import React, { FunctionComponent } from "react";
import styled, { css } from "styled-components";

interface InfoProps {
  className?: string;
  inSidebar?: boolean;
}

export const Info: FunctionComponent<InfoProps> = ({
  className,
  children,
  inSidebar,
}) => {
  return (
    <InfoWrapper className={className || ""} inSidebar={inSidebar}>
      {children}
    </InfoWrapper>
  );
};

const InfoWrapper = styled.div<{ inSidebar?: boolean }>`
  text-align: left;

  > h3,
  > p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    ${({ inSidebar }) =>
      inSidebar
        ? css`
            -webkit-line-clamp: 1;
          `
        : null}
  }

  > h3 {
    margin: 0px;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;

    ${({ inSidebar }) =>
      inSidebar
        ? css`
            font-size: 14px;
          `
        : null}
  }

  > p {
    font-family: ${({ theme }) => theme.fonts.UrbaneDemiBold};
    color: ${({ theme }) => theme.colors.primary};
    margin: 0px;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    opacity: 0.7;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.laptopS}px`}) {
    &.highlight {
      > h3,
      > p {
        text-align: center;
        white-space: pre-wrap;
        text-overflow: ellipsis;
      }
    }

    > h3,
    > p {
      white-space: pre-wrap;
      text-overflow: ellipsis;
    }
  }
`;
